"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var client_1 = require("react-dom/client");
var app_1 = require("./app");
var root = (0, client_1.createRoot)((_a = document.getElementById("app")) !== null && _a !== void 0 ? _a : document.body);
root.render((0, jsx_runtime_1.jsx)(app_1.App, {}));
